import { AttestationType } from 'app/constants/attestationType'

export const getAttestationName = (type: AttestationType, t) => {
  let name = '-'

  switch (type) {
    case AttestationType.AVAILABILITY:
      name = t('attestationName.availability')
      break
    case AttestationType.DRIVING:
      name = t('attestationName.driving')
      break
    case AttestationType.REST:
      name = t('attestationName.rest')
      break
    case AttestationType.SICKLEAVE:
      name = t('attestationName.sickleave')
      break
    case AttestationType.TIMEOFF:
      name = t('attestationName.timeoff')
      break
    case AttestationType.WORK:
      name = t('attestationName.work')
      break
  }

  return name
}
